/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useIntl } from "react-intl";
import {PageLink, PageTitle} from "../../components/layout/core";

const reportsBreadCrumbs: Array<PageLink> = [
  {
    title: "Shikoyat yuborish",
    path: "/",
    isSeparator: false,
    isActive: false,
  },
];

const ReportsNew: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: "MENU.ReportsNew" })}
      </PageTitle>
      <PageTitle
          breadcrumbs={reportsBreadCrumbs}
          // toolbar={dashboardToolbars}
      />
      <div className={"bg-white rounded-4 border border-gray-200 p-20 pt-1"}>
        <div className={"p-20"}>
          <div className={"mb-20"}>
            <h1 className={"fw-bold"}>Ma’lumotlarni kiriting</h1>
            <p className={"text-gray-500 fw-bold"}>Shikoyat yuborish uchun ma’lumotlarni kiriting</p>
          </div>
          <div className="mb-10">
            <label className="form-label">Mavzu <sup className={"text-danger"}>*</sup></label>
            <input
                type="text"
                className="form-control"
                placeholder="Shikoyat mavzusini kiriting"
            />
          </div>
          <div className="mb-10">
            <label className="form-label">Telefon raqam</label>
            <input
                type="text"
                className="form-control"
                placeholder="+998(90) 123-45-67"
            />
          </div>
          <div className="mb-10">
            <label className="form-label">Qo’shimcha telefon raqam</label>
            <input
                type="text"
                className="form-control"
                placeholder="Qo’shimcha telefon raqam"
            />
          </div>

          <div className="mb-10">
            <label className="form-label">Qo’shimcha izoh</label>
            <textarea
                className="form-control"
                placeholder="Matnini kiriting"
                rows={3}
            />
          </div>

          <div className={"text-end"}>
            <button type={"button"} className={"btn btn-primary"}>Saqlash</button>
          </div>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aut exercitationem odit recusandae similique.
          Adipisci aliquam aperiam architecto aspernatur consectetur, distinctio eaque earum eius error eveniet
          exercitationem facilis fuga fugiat illum ipsa iste laboriosam magnam nam nobis nostrum pariatur perferendis
          possimus praesentium provident quasi qui quidem repellat reprehenderit sequi similique sit tempora tempore, ut
          vel voluptas voluptate voluptates. Amet consectetur debitis nihil praesentium quod similique ullam. Accusamus
          atque blanditiis, consequatur consequuntur dicta dolorum exercitationem in ipsam laudantium maiores minus
          nostrum quos reprehenderit similique sunt vel, veritatis? Consequuntur eveniet facere itaque minima quas
          reprehenderit. Nam nemo, pariatur quibusdam repellat rerum tempore.
        </div>
      </div>
    </>
  );
};

export {ReportsNew};
